import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=381c01cb&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('381c01cb')) {
      api.createRecord('381c01cb', component.options)
    } else {
      api.reload('381c01cb', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=381c01cb&", function () {
      api.rerender('381c01cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zCDZhw8C4LOg/JS/comp/FavElement.vue"
export default component.exports